const landlord = [{
  path: '/landlord',
  component: () => import('@/landlord/pages/Index'),
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'Landlord',
    meta: { requiresAuth: true },
    component: () => import("@/landlord/pages/Landlord.vue")
  },
  {
    path: 'details/:id',
    name: 'LandLordDetails',
    params: true,
    meta: { requiresAuth: true },
    component: () => import('@/landlord/pages/ViewAndEditLandlord.vue')
  }]
}]

export default landlord
